import { useNavigate } from "react-router";
import { useEffect } from "react";
import { LoadingPage } from "@inductiveautomation/ws-components";
import {
  getAccountRedirectUrl,
  clearAccountRedirectUrl,
} from "../../utilities/redirectUrl";

const Callback = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const redirectUri = getAccountRedirectUrl();
    // Strict mode causes components the componets to mount twice
    // this if block is primarily to defend against strange behavior in local development
    // in prod, this would only ever get called once due to the empty dependency array
    if (redirectUri) {
      void navigate(redirectUri);
      clearAccountRedirectUrl();
    }
  }, [navigate]);

  return (
    <LoadingPage baseAssetUrl={window._acctConfig?.BASE_ASSET_URL ?? ""} />
  );
};

export default Callback;
